import { z } from 'zod/v4';

import { normalizeSocialWidgetArgs } from './social-widget-args.normalization';
import { partialSocialItemSchema, partialSocialWidgetDataSchema } from './partial-social-widget-data.schema';

/**
 * `socials` is the one field promoted from optional to REQUIRED on create — everything else has a
 * sane factory default, but entity-core's factory seeds a single Telegram entry with an EMPTY link,
 * which renders an icon that goes nowhere. Declared via `.extend()` on the shared partial rather
 * than a hand-copied field list, so the two tools' surfaces can't drift.
 */
const createSocialWidgetDataSchema = partialSocialWidgetDataSchema.extend({
    socials: z
        .array(partialSocialItemSchema)
        .min(1)
        .describe('The entries to show — at least one, each with a network and a link.'),
});

const createSocialWidgetObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to create the social-networks widget in.'),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: createSocialWidgetDataSchema.describe(
        'Social widget data. Only socials is required; appearance, icon style, sizing, alignment and ' +
            'visibility all fall back to sane defaults.'
    ),
});

export const createSocialWidgetArgsSchema = z.preprocess(normalizeSocialWidgetArgs, createSocialWidgetObjectSchema);
